/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_JobsInputs */

const en_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs`)
};

const de_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen`)
};

const fr_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplois`)
};

const es_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleos`)
};

const it_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori`)
};

const nl_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banen`)
};

const pl_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prace`)
};

const fi_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työt`)
};

const da_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const sv_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb`)
};

/**
* | output |
* | --- |
* | "Jobs" |
*
* @param {Nav_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_jobs = /** @type {((inputs?: Nav_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_jobs(inputs)
	if (locale === "fr") return fr_nav_jobs(inputs)
	if (locale === "es") return es_nav_jobs(inputs)
	if (locale === "it") return it_nav_jobs(inputs)
	if (locale === "nl") return nl_nav_jobs(inputs)
	if (locale === "pl") return pl_nav_jobs(inputs)
	if (locale === "fi") return fi_nav_jobs(inputs)
	if (locale === "da") return da_nav_jobs(inputs)
	if (locale === "sv") return sv_nav_jobs(inputs)
	return en_nav_jobs(inputs)
});